/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterResourceTemplate = new PostFilter(
  [['guid', PostFilterComparison.eq]],
  'resource.template',
);
